import React from 'react'
import CreateTransaction from '../../../Component/transaction/createTransaction'

const DepositTransaction = () => {
  return (
    <div>
        <CreateTransaction callingParrent = "Deposit"/>
    </div>
  )
}

export default DepositTransaction